export class ReferralEmail {
  static htmlToPlainText(html: string): string {
    return (
      html
        // Replace common HTML elements with text equivalents
        .replace(/<p[^>]*>/gi, '')
        .replace(/<\/p>/gi, '\n\n')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<div[^>]*>/gi, '')
        .replace(/<\/div>/gi, '\n')
        .replace(/<hr[^>]*>/gi, '\n---\n')
        .replace(/<li[^>]*>/gi, '- ')
        .replace(/<\/li>/gi, '\n')
        .replace(/<ul[^>]*>|<\/ul>|<ol[^>]*>|<\/ol>/gi, '\n')
        // Remove all other HTML tags
        .replace(/<[^>]*>/g, '')
        // Clean up whitespace
        .replace(/&nbsp;/g, ' ')
        .replace(/\n\s*\n/g, '\n\n')
        // Decode HTML entities
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .trim()
    );
  }

  static buildCustomEmailHtml(
    contentHtml: string,
    referralUrl: string,
    recipientEmail: string
  ): string {
    const safeUrl = ReferralEmail._escapeHtml(referralUrl);
    const safeEmail = ReferralEmail._escapeHtml(recipientEmail);
    return `
<div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
  ${contentHtml}
  
  <p style="text-align: center; margin: 25px 0;">
    <a href="${safeUrl}" style="background-color: #3772FF; color: white; padding: 10px 20px; text-decoration: none; border-radius: 4px; font-weight: bold;">Access Your Referral</a>
  </p>

  <p style="text-align: center;">When asked to sign in, use <strong>${safeEmail}</strong>. This referral can only be opened with that email address.</p>

  <hr style="margin-top: 30px; border: 0; border-top: 1px solid #eee;">
  <p style="color: #777; font-size: 12px;">This is a secure patient referral. Please do not forward this email.</p>
</div>
    `;
  }

  static buildPatientEmailHtml(contentHtml: string): string {
    return `
<div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
  ${contentHtml}
  
  <hr style="margin-top: 30px; border: 0; border-top: 1px solid #eee;">
  <p style="color: #777; font-size: 12px;">This is a secure patient referral notification. Please do not forward this email.</p>
</div>
    `;
  }

  private static _escapeHtml(value: string): string {
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
}
